import { Box, BoxProps, IconButton, IconButtonProps, Tooltip } from "@mui/material"
import { Constants } from "../../utils/constants"
import { IconName, icons } from "../../utils/icons"
import { useSettingsStyles } from "./settingsStyles"
import { MouseEvent, useState } from "react"
import { useTranslation } from "react-i18next"
import BaseMenu, { BaseMenuProps } from "../baseMenu"

type ClickPayload = {
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    id: string
    positionxy: {} | {
        top: string;
        left: string;
    }
}
type SettingClick = (payload: ClickPayload) => void
type SettingsProps = {
    click?: SettingClick;
    rowLength?: number;
    setDetail?: any;
    row?: any;
    handleClick?: any;
    disable?: boolean;
    icon?: IconName
    menu?: MenuSetting
    iconProps?: IconButtonProps
    containerProps?: BoxProps
}

export type MenuSetting = Omit<BaseMenuProps, 'anchorEl' | 'setAnchorEl'>
export type { ClickPayload, SettingClick }
const Settings = (props: SettingsProps) => {
    const styles = useSettingsStyles()
    const { t } = useTranslation()
    const [anchorEl, setAnschorEl] = useState<HTMLElement | null>(null)
    const id = props?.row?.id
    return (
        <Box {...props.containerProps} sx={{...styles.containerStatus, ...props.containerProps?.sx}}>
            <Tooltip title={t('ToolTips.seeActions')}>
                <IconButton
                    disabled={!!props.disable}
                    onClick={(e) => {
                        setAnschorEl(e.currentTarget)
                        if (props.click) {
                            props.click({
                                e,
                                id,
                                positionxy: (props?.rowLength ?? 0) < Constants.numberOfRows
                                    ? {}
                                    : {
                                        top: `${e.clientY}px`,
                                        left: `${e.clientX - 120}px`,
                                    },
                            })
                        }
                        // donnot use all under here
                        if (props.setDetail) {
                            props.setDetail({
                                id,
                                reportUrl: props?.row?.status?.reportUrl,
                                positionMenu:
                                    (props.rowLength ?? 0) < Constants.numberOfRows
                                        ? {}
                                        : {
                                            top: `${e.clientY}px`,
                                            left: `${e.clientX - 120}px`,
                                        },
                            })
                        }
                        if (props.handleClick) {
                            props.handleClick(e)
                        }
                    }}
                    {...props.iconProps}
                >
                    {icons(props?.icon ?? 'moreHoriz')}
                </IconButton>
            </Tooltip>

            {!!props?.menu && (<BaseMenu {...props?.menu} setAnchorEl={setAnschorEl} anchorEl={anchorEl} />)}
        </Box>
    )
}

export { Settings }
